module.exports = __webpack_public_path__ + "static/img/C (13).4d45fc90.png";